/**
 * Complete Profile Task API
 * Feature: 019-build-a-framework
 */

import axiosInstance from '../axiosInstance';

export interface CompleteProfileTaskRequest {
  enrollmentId: number;
  completedByUserId: number;
}

export interface CompleteProfileTaskResponse {
  completed: boolean;
  completedAt: string;
  validatedFields: string[];
}

export interface ProfileIncompleteError {
  error: string;
  missingFields: string[];
  requiredFields: string[];
}

export const completeProfileTask = async (
  pathItemId: number,
  request: CompleteProfileTaskRequest
): Promise<CompleteProfileTaskResponse> => {
  try {
    const response = await axiosInstance.post<CompleteProfileTaskResponse>(
      `/api/path-items/${pathItemId}/complete-profile-task`,
      request
    );

    return response.data;
  } catch (error: any) {
    // Re-throw with parsed error data for 422 Unprocessable Entity
    if (error.response?.status === 422) {
      throw {
        status: 422,
        data: error.response.data as ProfileIncompleteError,
      };
    }
    throw error;
  }
};
